import { useEffect, useState } from "react";
import { useStore } from "../store/globalState";

/**
 * Seconds left before a new send is allowed (backend SEND_COOLDOWN after a
 * failed operation). Returns 0 when there is no cooldown.
 */
export const useSendCooldown = (): number => {
  const retryAvailableAt = useStore((state) => state.retryAvailableAt);
  const setRetryAvailableAt = useStore((state) => state.setRetryAvailableAt);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!retryAvailableAt) return;
    const id = setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= retryAvailableAt) {
        setRetryAvailableAt(null);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [retryAvailableAt, setRetryAvailableAt]);

  if (!retryAvailableAt) return 0;
  return Math.max(0, Math.ceil((retryAvailableAt - now) / 1000));
};
